if (!customElements.get('collection-infinite-scroll')) {
    customElements.define(
      'collection-infinite-scroll',
      class CollectionInfiniteScroll extends HTMLElement {
        constructor() {
          super()

          this.pageLoadingType = performance.getEntriesByType("navigation")[0].type
          this.currentUrl = new URL(window.location.href)
          this.scrollStorageIndexName = `${window.location.pathname}-scroll`
          this.productGrid = this.querySelector('.product-list')
          this.paginatePerPage = parseInt(this.dataset.perPage)
          this.loadMore = this.querySelector('#loadMore')
          this.loading = false
          this.canLoadMore = true
          this.currentPage = parseInt(new URLSearchParams(this.currentUrl.search).get('page')) || 1
          this.earliestPage = this.currentPage
          this.latestPage = this.currentPage
          this.currentScrolledPage = this.currentPage
          this.loadedPages = [this.currentPage]
          this.prevScrollPos = window.scrollY
          this.navigationType = this.dataset.navigationType
        }

        resetPage() {
            if (this.pageLoadingType !== 'back_forward' && this.currentUrl.searchParams.get('page')) {
                localStorage.removeItem(this.scrollStorageIndexName)
                this.currentUrl.searchParams.delete('page')
                window.location.href = this.currentUrl.toString()
            }
        }

        getFirstVisibleElement(className) {
            const elements = this.querySelectorAll(className)

            for (const element of elements) {
                const rect = element.getBoundingClientRect()
                const isVisible = rect.top < window.innerHeight && rect.bottom - 90 > 0

                if (isVisible) {
                    return element
                }
            }

            return null
        }

        windowBeforeUnload() {
            if (this.currentUrl.searchParams.get('page') > 1) {
                localStorage.removeItem(this.scrollStorageIndexName)
                const nodeList = this.querySelectorAll('.product-list > .grid__item')
                const elementToFind = this.getFirstVisibleElement('.grid__item')
                const index = Array.from(nodeList).indexOf(elementToFind)

                if (index > -1) {
                    localStorage.setItem(scrollStorageIndexName, JSON.stringify({
                        index: index - (this.loadedPages.length - 1) * this.paginatePerPage,
                        offsetTop: elementToFind.getBoundingClientRect().top
                    }))
                }
            }
        }

        scrollToElementByIndex({ index, offsetTop }) {
            const elements = this.querySelectorAll('.grid__item')

            if (index >= 0 && index < elements.length) {
                setTimeout(function () {
                    window.scrollTo({
                        top: elements[index].getBoundingClientRect().top + window.scrollY + offsetTop,
                        behavior: 'smooth'}
                    )
                }, 1000)
            }
        }

        fetchProducts(params, isScrollDirectionDown, page, loadingButton, loadMore) {
            const fetchUrl = `${window.location.pathname}?${params.toString()}`
            this.loading = true
            const that = this

            loadingButton.style.display = 'block'
            if (loadMore) {
              that.loadMore.style.display = 'none'
            }

            const xhr = new XMLHttpRequest()
            xhr.open('GET', fetchUrl, true)
            xhr.onreadystatechange = function() {
              if (xhr.readyState === 4 && xhr.status === 200) {
                const data = xhr.responseText
                const parser = new DOMParser()
                const doc = parser.parseFromString(data, 'text/html')
                  console.log(doc.querySelectorAll('reveal-items .product-list > *:not(.no-results)'))
                const products = doc.querySelectorAll('reveal-items .product-list > *:not(.no-results)')

                if (products.length > 0) {
                    that.revealHiddenItems();
                    if (loadMore || isScrollDirectionDown) {
                        products.forEach((product) => {
                            document.dispatchEvent(new CustomEvent('theme:scroll:load-products', {
                                bubbles: true, detail: product
                            }))
                            that.productGrid.appendChild(product)
                        })
                        that.latestPage = page
                    } else {
                        that.earliestPage = page

                        for (let i = products.length - 1; i >= 0; i--) {
                            that.productGrid.insertBefore(products[i], that.productGrid.firstChild)
                        }
                    }

                    that.loadedPages.push(page)

                    if (loadMore && products.length < that.paginatePerPage) {
                        that.loadMore.style.display = 'none'
                        that.canLoadMore = false
                    }
                } else {
                    if (that.querySelector('.pagination-end') && isScrollDirectionDown) {
                        that.querySelector('.pagination-end').style.display = 'block';
                    }
                    that.canLoadMore = false
                }
                that.loading = false
                loadingButton.style.display = 'none'
                  
                  if (that.canLoadMore) {
                      that.hideIncompleteRow();
                  } else {
                      that.revealHiddenItems();
                  }

                if (loadMore) {
                    that.querySelector('.loaded').textContent = that.querySelectorAll('.grid__item').length

                    if (products.length > 0 && that.canLoadMore) {
                        that.loadMore.style.display = 'inline-flex'
                    }
                }
              }
            }
            xhr.send()
        }

        loadMoreProducts(page, isScrollDirectionDown, loadMore) {
            let loadMoreButtonBottom = this.querySelector('.load-more--bottom')
            let loadMoreButtonTop = this.querySelector('.load-more--top')
            const loadingButton = isScrollDirectionDown ? loadMoreButtonBottom : loadMoreButtonTop

            const params = new URLSearchParams(this.currentUrl.search)
            params.set('page', page)

            this.fetchProducts(params, isScrollDirectionDown, page, loadingButton, loadMore)
        }
        
        hideIncompleteRow () {
            const items = this.querySelectorAll('product-list .grid__item') || [];
            const productItems = this.querySelectorAll('product-list .product-card') || [];
            const bannersOneCol = this.querySelectorAll('.product-list__promo.columns-span--1') || [];
            const bannersTwoCol = this.querySelectorAll('.product-list__promo.columns-span--2') || [];
            const itemsLength = productItems.length + bannersOneCol.length + bannersTwoCol.length * 2;
            const modulo = itemsLength % 4;
            if (modulo === 1) {
                items[items.length - 1].classList.add('md:hidden')
            } else if (modulo === 2) {
                items[items.length - 1].classList.add('md:hidden')
                items[items.length - 2].classList.add('md:hidden')
            } else if (modulo === 3) {
                items[items.length - 1].classList.add('md:hidden')
                items[items.length - 2].classList.add('md:hidden')
                items[items.length - 3].classList.add('md:hidden')
            }
        }
        
        revealHiddenItems () {
            this.querySelectorAll('product-list .grid__item').forEach(el => {
                el.classList.remove('hidden', 'md:hidden')
            })
        }

        updateUrl(page) {
            const urlParams = new URLSearchParams(this.currentUrl.search);
            page > 1 ? urlParams.set('page', page) : urlParams.delete('page')
            history.pushState(null, null, `${this.currentUrl.pathname}?${urlParams.toString()}`);
        }

        isElementVisible(element, isScrollDirectionDown) {
            if (!element) {
                return false;
            }

            const rect = element.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
            return isScrollDirectionDown ? rect.top <= windowHeight : rect.bottom >= windowHeight;
        }

        handleScroll() {
            const currentScrollPos = window.scrollY
            const isScrollDirectionDown = currentScrollPos > this.prevScrollPos
            this.prevScrollPos = currentScrollPos

            const distanceToBottom = document.documentElement.offsetHeight - (window.innerHeight + currentScrollPos)
            const distanceToTop = currentScrollPos
            const pagesThreshold = this.currentScrolledPage + 1 - this.earliestPage

            if (pagesThreshold > 0) {
                const nextPageElIndex = pagesThreshold * this.paginatePerPage + 4
                const prevPageElIndex = pagesThreshold > 1 ? (pagesThreshold - 1) * this.paginatePerPage + 4 : -1
                const nextPageEl = this.querySelector(`.product-list > *:nth-child(${nextPageElIndex})`)
                const prevPageEl = this.querySelector(`.product-list > *:nth-child(${prevPageElIndex})`)

                if ((isScrollDirectionDown && this.isElementVisible(nextPageEl, true)) || (!isScrollDirectionDown && this.isElementVisible(prevPageEl, false))) {
                    this.currentScrolledPage = this.currentScrolledPage + (isScrollDirectionDown ? 1 : -1)
                    this.updateUrl(this.currentScrolledPage)
                }
            }

            if ((isScrollDirectionDown && this.getBoundingClientRect().bottom - window.innerHeight < 100 && !this.loading && this.canLoadMore) ||
                (!isScrollDirectionDown && this.currentPage > 1 && distanceToTop < this.productGrid.getBoundingClientRect().top - 100 && !this.loading)) {
                this.currentPage += isScrollDirectionDown ? 1 : -1
                if (!this.loadedPages.includes(this.currentPage)) {
                    this.loadMoreProducts(this.currentPage, isScrollDirectionDown)
                }
            }
        }

        throttle(func, limit) {
            let inThrottle;
            const context = this;
            const args = arguments;

            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;

                setTimeout(() => {
                    inThrottle = false;
                }, limit);
            }
        }

        throttledScroll () {
            const that = this;
            this.throttle(that.handleScroll, 250)
        }

        onLoadMoreClick() {
            this.currentPage++
            this.loadMoreProducts(this.currentPage, true, true)
        }

        connectedCallback() {
            this.resetPage()
            window.addEventListener('beforeunload', this.windowBeforeUnload)

            if (this.currentPage > 1 && localStorage.getItem(this.scrollStorageIndexName)) {
                this.scrollToElementByIndex(JSON.parse(localStorage.getItem(this.scrollStorageIndexName)))
            } else {
              this.hideIncompleteRow()
            }

            if (this.navigationType === 'infinite-scroll') {
                window.addEventListener('scroll', this.throttledScroll.bind(this))
            } else {
                this.loadMore.addEventListener('click', this.onLoadMoreClick.bind(this))
            }
        }

        disconnectedCallback() {
            window.removeEventListener('beforeunload', this.windowBeforeUnload)
            if (this.navigationType === 'infinite-scroll') {
                window.removeEventListener('scroll', this.throttledScroll.bind(this))
            } else {
                this.loadMore.removeEventListener('click', this.onLoadMoreClick.bind(this))
            }
        }
      }
    )
  }
